"use strict";

exports.__esModule = true;
exports.default = void 0;

var _dragDrop = _interopRequireDefault(require("@uppy/drag-drop"));

var _shallowEqual = require("shallow-equal");

var Vue = _interopRequireWildcard(require("vue"));

var _utils = require("./utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Cross compatibility dependencies
var _default = {
  data() {
    return {
      plugin: {}
    };
  },

  props: {
    uppy: {
      required: true
    },
    props: {
      type: Object
    }
  },

  mounted() {
    this.installPlugin();
  },

  methods: {
    installPlugin() {
      const {
        uppy
      } = this;
      const options = {
        id: 'vue:DragDrop',
        ...this.props,
        target: this.$refs.container
      };
      uppy.use(_dragDrop.default, options);
      this.plugin = uppy.getPlugin(options.id);
    },

    uninstallPlugin(uppy) {
      uppy.removePlugin(this.plugin);
    }

  },

  beforeDestroy() {
    this.uninstallPlugin(this.uppy);
  },

  beforeUnmount() {
    this.uninstallPlugin(this.uppy);
  },

  watch: {
    uppy(current, old) {
      if (old !== current) {
        this.uninstallPlugin(old);
        this.installPlugin();
      }
    },

    props(current, old) {
      if (!(0, _shallowEqual.shallowEqualObjects)(current, old)) {
        this.plugin.setOptions({ ...current
        });
      }
    }

  },

  render() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // Hack to allow support for Vue 2 and 3
    if ((0, _utils.isVue2)(...args)) {
      // If it's first argument is a function, then it's a Vue 2 App
      const [createElement] = args;
      return createElement('div', {
        ref: 'container'
      });
    } // Otherwise, we import the `h` function from the Vue package (in Vue 3 fashion)


    return Vue.h('div', {
      ref: 'container'
    });
  }

};
exports.default = _default;